import { create, StateCreator } from 'zustand';

import { ENetwork } from 'web3';

import { IGasPriceResponse } from '../../types';

type DexGasPrices = Record<ENetwork, IGasPriceResponse | undefined>;

interface DexGasPriceState {
  gasPrices: DexGasPrices;
}

interface DexGasPriceActions {
  setGasPrice: (network: ENetwork, gasPrice: IGasPriceResponse | undefined) => void;
  getGasPrice: (network: ENetwork) => IGasPriceResponse | undefined;
  reset: () => void;
}

const createInitialGasPrices = (): DexGasPrices =>
  Object.values(ENetwork).reduce<DexGasPrices>((acc, network) => {
    acc[network as ENetwork] = undefined;
    return acc;
  }, {} as DexGasPrices);

const dexGasPriceStore: StateCreator<DexGasPriceState & DexGasPriceActions> = (set, get) => ({
  gasPrices: createInitialGasPrices(),

  setGasPrice: (network, gasPrice) =>
    set(state => ({
      gasPrices: {
        ...state.gasPrices,
        [network]: gasPrice,
      },
    })),

  getGasPrice: network => get().gasPrices[network],

  reset: () =>
    set(() => ({
      gasPrices: createInitialGasPrices(),
    })),
});

export const useDexGasPriceStore = create(dexGasPriceStore);

export const getDexGasPriceFromStore = (network: ENetwork) =>
  useDexGasPriceStore.getState().getGasPrice(network);
